import { NavLink } from "react-router-dom";

const items = [
  {
    to: "/",
    label: "Inicio",
    icon: (
      <path d="M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10" />
    ),
  },
  {
    to: "/entreno",
    label: "Entreno",
    icon: <path d="M6 7v10M18 7v10M3 9v6M21 9v6M6 12h12" />,
  },
  {
    to: "/medidas",
    label: "Medidas",
    icon: (
      <path d="M4 19L19 4M7 16l1.5 1.5M10 13l1.5 1.5M13 10l1.5 1.5M16 7l1.5 1.5" />
    ),
  },
  {
    to: "/fotos",
    label: "Fotos",
    icon: (
      <>
        <rect x="3" y="7" width="18" height="13" rx="2" />
        <path d="M9 7l1.5-3h3L15 7" />
        <circle cx="12" cy="13" r="3.5" />
      </>
    ),
    lockBadge: true,
  },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 z-40 grid w-full max-w-[430px] -translate-x-1/2 grid-cols-4 border-t border-line bg-[rgba(8,12,22,.9)] px-1.5 pb-[calc(10px+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-md">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            `relative flex flex-col items-center gap-1 font-mono text-[9px] uppercase tracking-[0.1em] ${
              isActive ? "text-accent-bright [&_svg]:drop-shadow-[0_0_6px_rgba(46,107,255,.8)]" : "text-muted"
            }`
          }
        >
          {item.lockBadge && (
            <span className="absolute -top-1.5 left-[26px] h-[9px] w-[9px]">
              <svg viewBox="0 0 24 24" className="stroke-accent-bright" fill="none">
                <rect x="5" y="11" width="14" height="9" rx="2" />
                <path d="M8 11V7a4 4 0 0 1 8 0v4" />
              </svg>
            </span>
          )}
          <svg
            viewBox="0 0 24 24"
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {item.icon}
          </svg>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
